export const document = {
  mode: "zh",
  document: {
    title: "安全的出口运营管理",
    emphasize: "经验",
    description:
      "SEL-DI KOREA保有增值电信业务经营许可证 可直接运营跨境电商平台。",
    subDescription:
      "与服务信赖度同等重要的中国行政业务的稳定性 以令人信服的行政运营使客户成功进军中国。",
  },
};
